import { FormControl, Select, MenuItem, Grid, FormHelperText } from "@mui/material";
import { useCallback, useEffect, useState } from "react";

const CreditScore = ({ page, setPage, formData, setFormData }) => {
    const [errorMessage, setErrorMessage] = useState(null);

    const onCreditScoreChange = (e) => {
        setFormData({ ...formData, creditScore: e.target.value });
        setErrorMessage(null);
    }
    const updateFormData = useCallback(() => {
        setFormData(formData);
    }, [formData, setFormData]);

    useEffect(() => {
        updateFormData();
    }, [updateFormData]);

    useEffect(() => {
        setErrorMessage(null);
    }, [formData.lang]);

    return (
        <div className="card">
            <div className="card-div">
                <div className="textfield-label">{formData.lang === "fr" ? "Quelle est votre cote de crédit?" : "What is your credit score?"}</div>
                <FormControl>
                    <Select
                        variant="outlined"
                        value={formData.creditScore || ''}
                        onChange={(e) => onCreditScoreChange(e)}>
                        <MenuItem value={"good"}>{formData.lang === "fr" ? "700 et plus" : "700 and over"}</MenuItem>
                        <MenuItem value={"fair"}>561 - 700</MenuItem>
                        <MenuItem value={"low"}>{formData.lang === "fr" ? "Moins de 560" : "Less than 560"}</MenuItem>
                        <MenuItem value={"unknown"}>{formData.lang === "fr" ? "Je ne suis pas sûr" : "I'm unsure"}</MenuItem>
                    </Select>
                    <FormHelperText style={{ color: "red" }}>{errorMessage}</FormHelperText>
                </FormControl>

                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <button className="nav-button"
                            onClick={() => {
                                setPage(page - 1);
                            }}>
                            {formData.lang === "fr" ? "Précédent" : "Previous"}
                        </button>
                    </Grid>
                    <Grid item xs={6}>
                        <button className="nav-button"
                            onClick={() => {
                                if (formData.creditScore === "") {
                                    setErrorMessage(formData.lang === "fr" ? "Veuillez sélectionner votre pointage de crédit." : "Please select your credit score.");
                                } else {
                                    window.dataLayer.push({'event': 'loan_step4', 'loanEvent': 'step4', 'loanEventID': 5});
                                    // quebec only
                                    // window.dataLayer.push({'event': 'loan_step4q', 'loanEvent': 'step4q', 'loanEventID': '5q'});
                                    setPage(page + 1);
                                }
                            }}>
                            {formData.lang === "fr" ? "Suivant" : "Next"}
                        </button>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default CreditScore;